import { IdNamePair } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { viewsKeys } from '../../queryKeys/view';

export function useGetLocales(): UseQueryResult<IdNamePair[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getLocales = async () => {
    if (servicesCtx?.localesService) {
      return servicesCtx.localesService.getLocales();
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: viewsKeys.all,
    queryFn: getLocales,
    staleTime: Infinity,
    gcTime: Infinity
  });
}
